import React from 'react';
import { Lock } from 'lucide-react';
interface CheckoutSectionProps {
  totalPrice: number;
  isBumpSelected: boolean;
}
export function CheckoutSection({
  totalPrice,
  isBumpSelected
}: CheckoutSectionProps) {
  const formatPrice = (price: number) => price.toFixed(2);
  const handleCheckoutClick = () => {
    // Fire Meta Pixel AddToCart event
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    // Redirect to appropriate Shopify checkout based on bump selection
    const checkoutUrl = isBumpSelected ? 'https://www.tubienestarinterno.com/cart/53346665300305:1' : 'https://www.tubienestarinterno.com/cart/53346355937617:1';
    window.location.href = checkoutUrl;
  };
  return <section id="checkout-section" className="py-12 px-4 bg-cloud-grey" data-id="element-8">
      <div className="max-w-3xl mx-auto text-center" data-id="element-9">
        <h2 className="text-3xl font-bold font-serif mb-8 text-gray-900" data-id="element-10">
          Complete su inscripción ahora
        </h2>

        <button onClick={handleCheckoutClick} className="w-full bg-brand-teal hover:bg-brand-teal-dark text-white font-bold py-4 px-6 sm:px-8 rounded-[20px] shadow-xl transition-all transform hover:-translate-y-1 text-base sm:text-lg flex flex-col items-center justify-center cursor-pointer" data-id="element-11">
          <span data-id="element-12">LLEVARME EL PACK COMPLETO</span>
          <span className="text-xs sm:text-sm font-medium text-teal-100 mt-1" data-id="element-13">
            (DOG-CALM {isBumpSelected ? '+ CÓDIGO SILENCIO ' : ''}+ 3 BONOS) — $
            {formatPrice(totalPrice)} USD
          </span>
        </button>

        <div className="mt-6 flex items-center justify-center text-gray-500 text-sm" data-id="element-14">
          <Lock className="w-4 h-4 mr-2" data-id="element-15" />
          <span data-id="element-16">Pago 100% seguro y encriptado</span>
        </div>

        {/* Payment Logos */}
        <div className="mt-6 flex items-center justify-center space-x-6 opacity-60 grayscale" data-id="element-17">
          <div className="font-bold text-xl tracking-tighter italic" data-id="element-18">VISA</div>
          <div className="flex items-center" data-id="element-19">
            <div className="w-6 h-6 rounded-full bg-red-500 mix-blend-multiply opacity-80" data-id="element-20"></div>
            <div className="w-6 h-6 rounded-full bg-yellow-500 mix-blend-multiply opacity-80 -ml-2" data-id="element-21"></div>
            <span className="ml-1 font-bold text-sm" data-id="element-22">mastercard</span>
          </div>
          <div className="font-bold text-blue-800 italic tracking-tight" data-id="element-23">
            PayPal
          </div>
        </div>
      </div>
    </section>;
}